import { c as _c } from "react/compiler-runtime";
// Segmented control — the admin's one way to switch between mutually exclusive
// views (table/chart, sellers/buyers, table/board).
//
// The pattern already existed inline in a few places; it lives here so every
// switcher looks and behaves identically instead of each page inventing its
// own tab styling.
import type { LucideIcon } from "lucide-react";
import { Button } from "@osmix/ui/button";
import { cn } from "@/lib/utils";
export type SegmentedOption<T extends string> = {
  value: T;
  label: string;
  icon?: LucideIcon;
};
export function Segmented(t0) {
  const $ = _c(12);
  const {
    value,
    options,
    onChange,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex max-w-full overflow-x-auto rounded-md border p-0.5", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== onChange || $[3] !== options || $[4] !== value) {
    let t3;
    if ($[6] !== onChange || $[7] !== value) {
      t3 = option => {
        const Icon = option.icon;
        const active = option.value === value;
        return <Button key={option.value} size="sm" role="tab" aria-selected={active} variant={active ? "secondary" : "ghost"} onClick={() => onChange(option.value)}>{Icon && <Icon className="size-4" />}{option.label}</Button>;
      };
      $[6] = onChange;
      $[7] = value;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    t2 = options.map(t3);
    $[2] = onChange;
    $[3] = options;
    $[4] = value;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[9] !== t1 || $[10] !== t2) {
    t3 = <div className={t1} role="tablist">{t2}</div>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}